<template>
  <CModal
    size="lg"
    centered
    :closeOnBackdrop="false"
    :show.sync="modalVisible"
    addContentClasses="border-0 modal-border-radius"
  >
    <div slot="header" />
    <div slot="header-wrapper" />
    <div slot="body-wrapper">
      <closeButton :setModalVisible="setModalVisible" />
      <CContainer style="padding: 3.125rem">
        <CRow alignHorizontal="between">
          <div style="width: 50%">
            <div class="modal-title row-header">Profile info</div>
            <div style="width: 80%">
              <div class="box picture modal-detail" />
              <div class="modal-detail">
                <div class="input-label">Name</div>
                <input placeholder="NAME" class="input input-text" />
              </div>
              <div class="modal-detail">
                <div class="input-label">Citizen ID</div>
                <input placeholder="00000000" class="input input-text" />
              </div>
              <div class="modal-detail">
                <div class="input-label">E-mail</div>
                <input placeholder="E-MAIL" class="input input-text" />
              </div>
              <div class="modal-detail">
                <div class="input-label">Birthday</div>
                <input type="date" class="input input-date" />
              </div>
              <div>
                <div class="input-label">Address</div>
                <input placeholder="ADDRESS" class="input input-text" />
              </div>
            </div>
          </div>
          <div style="width: 50%">
            <div class="modal-title row-header">Rejected history</div>
            <div class="box history row-header">
              <div>
                <div class="flex-row">
                  <div class="rejector">Admin</div>
                  <div class="date">00 / 00 / 0000 00:00</div>
                </div>
                <div>Text</div>
              </div>
              <div>
                <div class="flex-row">
                  <div class="rejector">Admin</div>
                  <div class="date">00 / 00 / 0000 00:00</div>
                </div>
                <div>Text</div>
              </div>
            </div>
            <div class="box input row-header" />
            <div class="box row-header" style="display: flex; justify-content: flex-end">
              <div class="button button-pink">REJECT</div>
            </div>
            <div style="width: 100%; display: flex; justify-content: flex-end">
              <div class="button button-green">APPROVE</div>
            </div>
          </div>
        </CRow>
      </CContainer>
    </div>
    <div slot="footer" />
    <div slot="footer-wrapper" />
  </CModal>
</template>

<script>
import closeButton from "./closeButton";
export default {
  name: "ProfileInfo",
  props: {
    modalVisible: Boolean,
    setModalVisible: Function
  },
  components: {
    closeButton
  }
};
</script>

<style lang="scss">
.box {
  border-radius: 20px;
  width: 100%;
  &.picture {
    height: 180px;
    background-color: #ace4eb;
  }
  &.history {
    min-height: 380px;
    background-color: #f2f2f2;
    padding: 20px;
  }
  &.input {
    height: 100px;
    background-color: #f2f2f2;
  }
}
.flex-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  color: black;
}
.rejector {
  font-size: 20px;
  color: #0080ff;
  margin-right: 5px;
}
.date {
  font-size: 10px;
}
</style>